import ApiClient from '@afosto/api/ApiClient';

class Queue {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add a job for a printer
   *
   * @param {Object} body - The new print job
   * @param {Object} options - The additional request options
   * @returns {Promise}
   */
  addJob(body, options = {}) {
    return this.apiClient.request({
      url: `/spl/queue`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Get the status for a printjob
   *
   * @param {string} reference - The id of the job that we look for, returned when job is pushed to queue
   * @param {Object} options - The additional request options
   * @description Retrieve printjob status
   * @returns {Promise}
   */
  getJobStatus(reference, options = {}) {
    return this.apiClient.request({
      url: `/spl/queue/${reference}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get job history for account
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.printerId] - The printer id that we want to filter
   * @param {string} [query.status] - Status values that need to be considered for filter
   * @param {string} [query.tag] - The tag id that we want to filter for
   * @param {Object} options - The additional request options
   * @description Filter with a single value (multiple is not supported)
   * @returns {Promise}
   */
  listJobs(query = {}, options = {}) {
    const params = {
      printer_id: query.printerId,
      status: query.status,
      tag: query.tag,
    };

    return this.apiClient.request({
      url: `/spl/queue`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Set a job to a new status
   *
   * @param {string} reference - The id of the job that we look for, returned when job is pushed to queue
   * @param {Object} body - The new print job
   * @param {Object} options - The additional request options
   * @returns {Promise}
   */
  updateStatus(reference, body, options = {}) {
    return this.apiClient.request({
      url: `/spl/queue/${reference}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const queue = new Queue();

export default Queue;
